import sbjs from 'sourcebuster'

import { APP } from 'src/Configs/App'

const EXCLUDED_REFERRAL_HOSTS = [
  'checkout.stripe.com',
  'pay.stripe.com',
  'www.paypal.com',
  'paypal.com',
  'accounts.google.com',
  'accounts.spotify.com',
  'www.tiktok.com',
  'tiktok.com',
]

const isExcludedReferrer = (referrer: string): boolean => {
  try {
    return EXCLUDED_REFERRAL_HOSTS.includes(new URL(referrer).hostname)
  } catch {
    return false
  }
}

const startSourceBuster = (): void => {
  sbjs.init({
    domain: APP.SOURCEBUSTER_DOMAIN,
    timezone_offset: 1,
  })
}

export const initSourceBuster = (): void => {
  if (!isExcludedReferrer(document.referrer)) {
    startSourceBuster()
    return
  }

  const ownDescriptor = Object.getOwnPropertyDescriptor(document, 'referrer')

  Object.defineProperty(document, 'referrer', {
    configurable: true,
    get: () => '',
  })

  try {
    startSourceBuster()
  } finally {
    if (ownDescriptor) {
      Object.defineProperty(document, 'referrer', ownDescriptor)
    } else {
      Reflect.deleteProperty(document, 'referrer')
    }
  }
}
